import React, { useState, useEffect, useContext, Fragment } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { postMethod } from "../../requests";
import { BasicContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Checkbox } from "semantic-ui-react";

const Settings = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [settings, setSettings] = useState(null);
    const [formChanged, setFormChanged] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const [paymentTypes, setPaymentTypes] = useState(null);

    const getGlobalSettings = async () => {
        const res = await postMethod("/get-global-settings");
        if (checkServerData(res)) {
            setSettings(res.data.settings);
            getPaymentTypes();
        }
    };

    const getPaymentTypes = async () => {
        const res = await postMethod("/get-payment-types");
        if (checkServerData(res)) {
            //console.log(res.data.list);
            setPaymentTypes(res.data.list);
            setLoading(false);
        }
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        settings.forEach((s, i) => {
            if (s.setting_type === "INT" && !s.setting_value_int) {
                $(`#${s.setting_code}${i}`).addClass("is-invalid");
                errors.push(`${t("error.settingValueIsEmpty")} (${t("no.")} ${i})`);
            } else if (s.setting_type === "INT" && (s.setting_value_int.length === 0 || !s.setting_value_int.toString().replace(/\s+/, "") || s.setting_value_int.length > 11)) {
                $(`#${s.setting_code}${i}`).addClass("is-invalid");
                errors.push(`${t("error.settingValueIsInvalid")} (${t("no.")} ${i})`);
            }
            if (s.setting_type === "TEXT" && (!s.setting_value_text || s.setting_value_text.length === 0 || !s.setting_value_text.replace(/\s+/, ""))) {
                $(`#${s.setting_code}${i}`).addClass("is-invalid");
                errors.push(`${t("error.settingValueIsInvalid")} (${t("no.")} ${i})`);
            }
        });

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e, i) => {
                list.push({ variant: "danger", message: e, id: i });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t(`info.updatingSettings`) }]);
            setBlockForm(true);
            updateSettings();
        }
    };

    const updateSettings = async () => {
        const res = await postMethod("/update-settings", { settings: settings, paymentTypes: paymentTypes });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "updateSettings" }]);
            setFormChanged(false);
        }
        setBlockForm(false);
    };

    useEffect(() => {
        $(`#list`).css("min-height", `${window.innerHeight - $("#footerMain").outerHeight()}px`);
        getGlobalSettings();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Container fluid="lg" id="addEditPass">
                <Row>
                    <Col xs={12} className="px-4 my-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t(`settings.settings`)}</h1>
                    </Col>
                    {loading ? (
                        <Col xs={12} className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    ) : (
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Form onSubmit={checkValidation} autoComplete="off">
                                <Row>
                                    <Col xs={12}>
                                        <p className="h5 my-3">{t("payments.paymentTypesVisibility")}</p>
                                    </Col>
                                    {paymentTypes.map((e, i) => (
                                        <Col xs={12} lg={4} key={i}>
                                            <Form.Group className="mb-3" controlId={`paymentTypeActive${i}`}>
                                                <Checkbox
                                                    toggle
                                                    label={t(`payments.paymentTypes.${e.payment_type_code}`)}
                                                    checked={e.payment_type_active}
                                                    disabled={blockForm}
                                                    onChange={() => {
                                                        const list = [...paymentTypes];
                                                        list.forEach((el) => {
                                                            if (el.payment_type_code === e.payment_type_code) el.payment_type_active = !el.payment_type_active;
                                                        });
                                                        setPaymentTypes(list);
                                                        $(`#paymentTypeActive${i}`).removeClass("is-invalid");
                                                        setFormChanged(true);
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    ))}
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <p className="h5 my-3">{t("settings.otherSettings")}</p>
                                    </Col>
                                    {settings.map((s, i) => (
                                        <Col xs={12} lg={4} key={i}>
                                            <Form.Group className="mb-3" controlId={`${s.setting_code}${i}`}>
                                                <Form.Label className="w-100">
                                                    {s.setting_name} <span className="req">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    value={s.setting_value_int}
                                                    placeholder={t("typeNumber")}
                                                    onChange={(e) => {
                                                        const list = [...settings];
                                                        list.forEach((l) => {
                                                            if (l.setting_code === s.setting_code) l.setting_value_int = e.target.value;
                                                        });

                                                        setSettings(list);
                                                        setFormChanged(true);
                                                        $(`${s.setting_code}${i}`).removeClass("is-invalid");
                                                    }}
                                                    type={s.setting_type === "INT" ? "number" : "text"}
                                                />
                                            </Form.Group>
                                        </Col>
                                    ))}
                                </Row>
                                <Row className="sticky-bottom bg-light-primary">
                                    <Col xs={12}>
                                        <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !formChanged}>
                                            {t("saveChanges")}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default Settings;
